import { StaticImage } from 'gatsby-plugin-image';
import type { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { LinkWithTitle } from '@/components/links';

export const UNIVERSITY_OF_TAMPA_TITLE =
  'University of Tampa';

export const Head = () => {
  return (
    <ComponentsHead
      title="Boat Tours Near University of Tampa | Scenic Charter Route"
      description="Sail past the iconic University of Tampa and Riverwalk with skyline views, historic landmarks, and unforgettable city vibes — all from a private charter."
      keywords="University of Tampa, Hillsborough River, Campus Cruise, Riverwalk"
    />
  );
};
const Page: FC = () => {
  return (
    <AddOnsTemplate
      title="University of Tampa Boat Charters – Cruise Past Tampa’s Most Iconic Campus"
      subtitle=""
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${UNIVERSITY_OF_TAMPA_TITLE} header`}
              src="../../images/areas/university-of-tampa/0.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
      <p>
        Just across the Hillsborough River from Downtown
        lies one of Tampa’s most iconic landmarks—the
        University of Tampa. Known for its Moorish
        architecture and stunning minarets, the UT campus
        creates a picturesque setting that’s even more
        impressive when viewed from the water. Our boat
        charters near the University of Tampa blend scenic
        cruising with a relaxed vibe, making this area a
        fantastic addition to your Tampa Bay experience.
      </p>
      <p>
        As we cruise past the university, you’ll enjoy views
        of Plant Hall, the Tampa Riverwalk, and the peaceful
        stretches of the river that wind through this
        historic part of town. It’s the perfect option for a
        laid-back afternoon charter or a unique sunset
        cruise.
      </p>
      <p>
        If you're looking to explore beyond the city limits,
        our charters also allow you to venture out into
        Tampa Bay, stop at local sandbars, or simply float
        and take in the skyline from a distance.
      </p>
      <h3>Available Charters Near University of Tampa:</h3>
      <ul>
        <li>
          <LinkWithTitle to="/charters/8-hour-charter/">
            8-Hour Private Party Boat
          </LinkWithTitle>
          : Dive into a full-day adventure that includes
          cruising past the University of Tampa and
          extending your trip out to the bay or nearby
          islands. Perfect for a full day of sightseeing,
          sun, and fun.
        </li>
        <li>
          <LinkWithTitle to="/charters/6-hour-charter/">
            6-Hour Private Party Boat
          </LinkWithTitle>
          : Spend six hours soaking up Tampa’s river and bay
          views, with time to relax, swim, and capture those
          unforgettable skyline shots.
        </li>
        <li>
          <LinkWithTitle to="/charters/4-hour-charter/">
            4-Hour Private Party Boat
          </LinkWithTitle>
          : This half-day cruise offers a relaxed experience
          close to the city—great for those wanting a
          scenic, easygoing boat day.
        </li>
        <li>
          <LinkWithTitle to="/charters/3-hour-charter/">
            3-Hour Sunset Charter
          </LinkWithTitle>
          : There’s nothing quite like the sun setting
          behind the minarets of the University of Tampa.
          Capture golden hour on the river for an
          unforgettable evening on the water.
        </li>
        <li>
          <LinkWithTitle to="/charters/wave-rave-charter/">
            3-Hour Wave Rave Charter
          </LinkWithTitle>
          : Short, sweet, and full of energy. This cruise
          keeps it fun and fast-paced while gliding past the
          university and surrounding sights.
        </li>
        <li>
          <LinkWithTitle to="/charters/snorkeling/">
            Snorkeling Charters
          </LinkWithTitle>
          : We’ll head to clearer waters near the St
          Petersburg where you can hop in, swim, and see
          what’s beneath the surface. A great option for
          combining sightseeing with adventure.
        </li>
        <li>
          <LinkWithTitle to="/charters/snorkeling/">
            Large Group Boat Charter
          </LinkWithTitle>
          : Bring your group and let us handle the details.
          Whether it’s a graduation celebration, birthday,
          or casual get-together, we’ll cruise in comfort
          with plenty of space for everyone.
        </li>
        <li>
          <LinkWithTitle to="/charters/large-group-charters/">
            Large Group Boat Charter
          </LinkWithTitle>
          : Bring your group and let us handle the details.
          Whether it’s a graduation celebration, birthday,
          or casual get-together, we’ll cruise in comfort
          with plenty of space for everyone.
        </li>
      </ul>
      <p>
        The University of Tampa is more than just a
        landmark—it’s a scenic gem that enhances your boat
        day with beauty and charm. Let Tampa Bay Boating
        Adventures show you this iconic spot from a new
        point of view.
      </p>
    </AddOnsTemplate>
  );
};

export default Page;
